module.exports = __webpack_public_path__ + "img/Pattern06.02c96e74.png";